import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function spreadImg() {
  gsap.registerPlugin(ScrollTrigger);

  if (document.querySelector('.js-spreadImgScrollItem')) {
    gsap.to('.js-spreadImgScrollItem', {
      width: '100%', // スクロールで100%まで拡大
      ease: 'none',
      scrollTrigger: {
        trigger: '.js-spreadImgScroll',
        start: 'top bottom', // 画像が画面下に入った瞬間から
        end: 'bottom center', // 画像が画面上から消えるまで
        // once: true,
        scrub: true, // スクロール量に連動
        // markers: true, // デバッグ用
      },
    });
  }
}
